import authTokenStorage from '@auth';
import { decamelize, decamelizeKeys } from 'humps';
import { AUTH_TOKEN_STORAGE_KEYS } from '@auth/constants';
import { isWhitelistedReq } from '../config/whitelistedUrlConfig';

// Recursively decamelizes keys but preserves fully uppercase identifiers
export const smartDecamelize = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(smartDecamelize);
  }

  if (obj && typeof obj === 'object' && obj.constructor === Object) {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
      // Preserve keys that are ALL CAPS or contain underscores (e.g. US, IE, OTHERS, SURGE_PRIORITY)
      const newKey = /^[A-Z0-9_]+$/.test(key) ? key : decamelize(key);
      result[newKey] = smartDecamelize(value);
    }
    return result;
  }

  return obj;
};

export const requestInterceptor = (config) => {
  const token = authTokenStorage.getAppToken(AUTH_TOKEN_STORAGE_KEYS.APP_TOKEN);
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  config.headers['x-device-id'] = authTokenStorage.getDeviceId();

  if (config.headers['Content-Type'] !== 'multipart/form-data') {
    if (config.params) config.params = decamelizeKeys(config.params);

    if (config.data) {
      let data = {};

      if (isWhitelistedReq(config.url)) {
        // Use smart decamelizer (preserves uppercase keys like US, OTHERS)
        data = smartDecamelize(config.data);
      } else {
        // Default global decamelization
        data = smartDecamelize(config.data);
      }

      // Preserve manual exceptions
      if (config.data.countryCode) {
        delete data.country_code;
        data.countryCode = config.data.countryCode;
      }

      config.data = data;
    }
  }

  const heavyEndpoints = [
    '/application/verify',
    '/notarization',
    '/admin/vda',
    '/admin/vda/stats',
    '/workflows/v2'
  ];

  if (config.url.includes('/ybl/trigger')) {
    config.timeout = null;
  } else if (heavyEndpoints.some(endpoint => config.url.includes(endpoint))) {
    config.timeout = 30000;
  }

  return config;
};
